 // SHOW MAIL AND TEL
function loadBtns_actions() {
    // var arrayMailColumnAnimations = [];
    var arrayTelColumnAnimations = [];

    let btnsTel = $('.btn-show-tel-column');
    let closeIconTel = $('.close-mail-icon-column');

    function makeAnimation(element, i) {
        //console.log('element', element)
      var tlTelColumn = undefined;
      tlTelColumn = new TimelineMax({paused:true});
      tlTelColumn.to(element, 0.5, {autoAlpha: 0, x:-10, display:"none", ease: Power3.easeOut}, "0.1")
      .fromTo(element.next(), 0.5, {autoAlpha: 0, x:10, display:"none", ease: Power3.easeOut}, {autoAlpha: 1, x:0, display:"block", ease: Power3.easeOut}, "+=0.1");

      arrayTelColumnAnimations[i] = tlTelColumn
      // console.log('tlTelColumn', tlTelColumn)      
    }

    $.each(btnsTel, function(i, el) {
      makeAnimation($(el), i)
    })

    //console.log('arrayTelColumnAnimations', arrayTelColumnAnimations)

    $(btnsTel).on('click', function(e) {
      let index = $(btnsTel).index( this );
        //console.log('index ?',  index)
      arrayTelColumnAnimations[index].timeScale(3).play()
      // tlTelColumn.reversed() ? tlTelColumn.play() : tlTelColumn.reverse();
    });
    
    closeIconTel.on('click', function(e) {
      e.preventDefault();
      let index = $(closeIconTel).index( this );
      arrayTelColumnAnimations[index].timeScale(3).reverse();
    })
   

}

module.exports = loadBtns_actions;
    
 